/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Rounds_Choice_Group_Cut_Bo3Inputs */



/**
* | output |
* | --- |
* | "Group stage + top cut - BO3" |
*
* @param {Tournaments_Lib_Rounds_Choice_Group_Cut_Bo3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_rounds_choice_group_cut_bo3 = /** @type {((inputs?: Tournaments_Lib_Rounds_Choice_Group_Cut_Bo3Inputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Rounds_Choice_Group_Cut_Bo3Inputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppenphase + Top Cut - BO3")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Phase de groupes + top cut - BO3")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("小组赛 + 淘汰赛 - BO3")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("分組賽 + 晉級賽 - BO3")
	if (locale === "ko") return /** @type {LocalizedString} */ ("그룹 스테이지 + 상위 컷 - BO3")
	return /** @type {LocalizedString} */ ("Group stage + top cut - BO3")
});